import Vue from "vue";
import Vuex from "vuex";
import { TrialApi } from "@/trials-api";

Vue.use(Vuex);

const pickById = (acc, cur) => ({ ...acc, [cur.id]: cur });

export default new Vuex.Store({
  state: {
    trialMap: {},
    typesMap: {},
    trial_details_route_from: undefined
  },
  getters: {
    trials: state => Object.values(state.trialMap),
    types: state => Object.values(state.typesMap).map(type => type.name)
  },
  mutations: {
    setTrial(state, trial) {
      Vue.set(state.trialMap, trial.id, trial);
    },
    setTrials(state, trials) {
      state.trialMap = trials.reduce(pickById, {});
    },
    setTrialTypes(state, types) {
      state.typesMap = types.reduce(pickById, {});
    },
    set_trial_details_route_from(state, value) {
      state.trial_details_route_from = value
    }
  },
  actions: {
    async listTrials({ commit }, { type = undefined }) {
      const trials = await TrialApi.search(type);
      commit("setTrials", trials);
      return trials;
    },
    async get({ state, commit }, { trialId }) {
      if (state.trialMap[trialId]) {
        return state.trialMap[trialId];
      }
      const trial = await TrialApi.get(trialId);
      commit("setTrial", trial);
      return trial;
    },
    submitClientData(ctx, { userData }) {
      return TrialApi.submitClientDetails(userData);
    },
    submitContactForm(ctx, { userData }) {
      return TrialApi.submitContactForm(userData);
    }
  },
  modules: {}
});
